import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classnames from "classnames"
import withStyles from "@material-ui/core/styles/withStyles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Hidden from "@material-ui/core/Hidden"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import BackIcon from "react-icons/lib/md/arrow-back"
import { translate } from "react-i18next"
import flow from "lodash/flow"
import styles from "./styles"
import { Tooltip } from "@material-ui/core"

import { getTitle } from "./../../../App/RouteCourse/RouteProfile/helpers";

export const TopNavigation = ({
    t, classes, backLink, backFunc, transparent, rightElement,
    title, tabs, selectedTab, baseUrl,
}) => {
    const onlyRightElement = !backLink
        && !backFunc
        && !title
        && !tabs
        && !!rightElement

    const createBackButton = () => (
        <Tooltip title={t("main:back")}>
            <IconButton
                color="inherit"
                className={classes.leftButton}
                component={backLink ? Link : "div"}
                to={backLink}
                onClick={backFunc}
                aria-label={t("main:back")}
            >
                <BackIcon />
            </IconButton>
        </Tooltip>
    )
    return (
        <AppBar
            position="static"
            className={classnames(classes.appBar, transparent && classes.transparent)}
        >
            <Toolbar
                className={classnames({
                    [classes.toolbar]: true,
                    [classes.toolbarNoMiddle]: !title && !tabs,
                    [classes.toolbarOnlyRightElement]: onlyRightElement,
                })}
            >
                {(backLink || backFunc) && createBackButton()}
                {title && (
                    <Typography variant="body2" color="inherit" className={classes.title}>
                        {title}
                    </Typography>
                )}
                {(tabs && tabs.length > 0) && (
                    <Hidden xsDown>
                        <Tabs
                            classes={{
                                indicator: classes.tabIndicator,
                            }}
                            value={selectedTab}
                            variant="fullWidth"
                            className={classes.tabs}
                        >
                            {tabs.map((tab, index) => {
                                let ariaLabelTitle = getTitle(tab.url, t, t("main:notifications"));
                                return (
                                    typeof tab.url === "string" && (
                                        <Tab
                                            key={tab.id}
                                            value={index}
                                            label={tab.title}
                                            to={tab.url ? `${baseUrl}/${tab.url}` : baseUrl}
                                            component={Link}
                                            className={classes.tab}
                                            classes={{ wrapper: classes.tabLabel }}
                                            aria-label={`${t("main:navigation")} ${ariaLabelTitle}`}
                                        />
                                    )
                                )
                            })}
                        </Tabs>
                    </Hidden>
                )}
                {rightElement}
            </Toolbar>
            {(tabs && tabs.length > 0) && (
                <Hidden smUp>
                    <Tabs
                        value={selectedTab}
                        variant="fullWidth"
                        className={classes.tabs}
                    >
                        {tabs.map((tab, index) => (
                            <Tab
                                key={tab.id}
                                value={index}
                                label={tab.title}
                                to={tab.url ? `${baseUrl}/${tab.url}` : baseUrl}
                                component={Link}
                                className={classes.tab}
                                classes={{ wrapper: classes.tabLabel }}
                            />

                        ))}
                    </Tabs>
                </Hidden>
            )}
        </AppBar>
    )
}

TopNavigation.propTypes = {
    classes: PropTypes.object.isRequired,
    backLink: PropTypes.object,
    backFunc: PropTypes.func,
    transparent: PropTypes.bool,
    rightElement: PropTypes.node,
    title: PropTypes.string,
    tabs: PropTypes.array,
    selectedTab: PropTypes.number,
    baseUrl: PropTypes.string,
}

TopNavigation.defaultProps = {
    backLink: null,
    backFunc: null,
    transparent: false,
    rightElement: null,
    title: null,
    tabs: null,
    selectedTab: 0,
    baseUrl: "/courses",
}

export default flow(
    withStyles(styles),
    translate(),
)(TopNavigation)
